import React from 'react';
import { ChartConfig } from '../../types';
import { FieldPicker } from './FieldPicker'; // Assuming FieldPicker is exported or I need to move it

interface HeatmapMappingZoneProps {
    config: ChartConfig;
    onUpdateConfig: (updates: Partial<ChartConfig>) => void;
    allCols: { label: string, value: string, isNumeric?: boolean, isConnection?: boolean }[];
    numericCols: { label: string, value: string, isNumeric?: boolean, isConnection?: boolean }[];
}

export const HeatmapMappingZone: React.FC<HeatmapMappingZoneProps> = ({ config, onUpdateConfig, allCols, numericCols }) => {
    return (
        <div className="space-y-4">
            <h3 className="text-xs font-bold text-neon-blue/70 uppercase tracking-widest flex items-center gap-2">
                Mapping
            </h3>

            <div className="space-y-3">
                <FieldPicker
                    label="X Categories (Columns)"
                    value={config.xCategoryField}
                    onChange={(val) => onUpdateConfig({ xCategoryField: val })}
                    options={allCols}
                />

                <FieldPicker
                    label="Y Categories (Rows)"
                    value={config.yCategoryField}
                    onChange={(val) => onUpdateConfig({ yCategoryField: val })}
                    options={allCols}
                />

                <FieldPicker
                    label="Value (Color)"
                    value={config.valueField}
                    onChange={(val) => onUpdateConfig({ valueField: val })}
                    options={numericCols}
                />

                <div className="h-px bg-white/10 w-full my-2" />

                <FieldPicker
                    label="Image Labels (Optional)"
                    value={config.imageField}
                    onChange={(val) => onUpdateConfig({ imageField: val })}
                    options={allCols}
                    allowNone={true}
                />
            </div>
        </div>
    );
};
